import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'; // Import Vuetify styles

// Create the Vuetify instance
const vuetify = createVuetify({
    theme: {
        defaultTheme: 'light',
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        },
    },
});

createApp(App).use(store).use(router).use(vuetify).mount('#app')
